export default "__VITE_ASSET__CY6C_6om__"